import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { siteKey: { type: String, default: "" } }
  static targets = ["button", "container", "input"]

  connect() {
    if (this.siteKeyValue === "") {
      return
    }

    if (!window.turnstile) {
      this.loadTurnstileScript()
    }

    this.element.addEventListener("submit", (event) => {
      if (this.inputTarget.value === "") {
        event.preventDefault()
        this.initTurnstile()
      }
    })
  }

  loadTurnstileScript() {
    const script = document.createElement("script")
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=onTurnstileLoad"
    script.defer = "defer"
    script.async = true

    window.onTurnstileLoad = () => {}
    document.body.appendChild(script)
  }

  disconnect() {
    if (this.widgetId) {
      turnstile.remove(this.widgetId)
    }
  }

  disableButton() {
    this.buttonTarget.disabled = true
    this.buttonTarget.classList.add("cursor-not-allowed.opacity-50")
  }

  enableButton() {
    this.buttonTarget.disabled = false
    this.buttonTarget.classList.remove("cursor-not-allowed.opacity-50")
  }

  initTurnstile() {
    this.disableButton()

    this.widgetId = turnstile.render(this.containerTarget, {
      sitekey: this.siteKeyValue,
      theme: "light",
      size: "flexible",
      "before-interactive-callback": () => {
        setTimeout(() => {
          App.displayFlash("warning", `Proceed with the verification to confirm you are human.`)
        }, 1000)
        this.disableButton()
        this.containerTarget.classList.remove("hidden")
      },
      "after-interactive-callback": () => {
        this.containerTarget.classList.add("hidden")
        this.enableButton()
      },
      callback: (token) => {
        this.inputTarget.value = token
        this.inputTarget.form.submit()
      },
    })
  }
}
